// src/slices/0-media/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getMedia, addMedia, deleteMedia } from "./thunk";

const initialState = {
  images: [],
  videos: [],
  documents: [],
  loading: false,
  uploading: false,
  error: null,
  pagination: {
    images: { total: null, totalPages: null, page: null, limit: null, hasNextPage: false, hasPrevPage: false },
    videos: { total: null, totalPages: null, page: null, limit: null, hasNextPage: false, hasPrevPage: false },
    documents: { total: null, totalPages: null, page: null, limit: null, hasNextPage: false, hasPrevPage: false }
  }
};

const mediaSlice = createSlice({
  name: "mediaReducer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // GET ALL
    builder.addCase(getMedia.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getMedia.fulfilled, (state, action) => {
      state.loading = false;


      const { type, data } = action.payload;

      state[type] = data?.data || [];

      if (data?.responseDetails?.pagination) {
        const p = data.responseDetails.pagination;

        state.pagination[type] = {
          total: data.responseDetails.totalCount || 0,
          totalPages: p.totalPages || 1,
          page: p.currentPage || 1,
          limit: p.pageSize || 10,
          hasNextPage: p.hasNextPage || false,
          hasPrevPage: p.hasPrevPage || false,
          nextPage: p.nextPage || null,
          prevPage: p.prevPage || null,
          itemsRemaining: p.itemsRemaining || 0,
          pagesRemaining: p.pagesRemaining || 0,
          startIndex: p.startIndex || 1,
          endIndex: p.endIndex || 10
        };

      } else {
      }
    });

    builder.addCase(getMedia.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.error || action.error.message;
    });

    // ADD / UPLOAD
    builder.addCase(addMedia.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(addMedia.fulfilled, (state, action) => {
      state.uploading = false;
      state[action.payload.type].unshift(action.payload.data);
    });
    builder.addCase(addMedia.rejected, (state, action) => {
      state.uploading = false;
      state.error = action.payload?.error || action.error.message;
    });

    // DELETE
    builder.addCase(deleteMedia.fulfilled, (state, action) => {
      state[action.payload.type] = state[action.payload.type].filter((item) => item.id.toString() !== action.payload.id.toString());
    });
    builder.addCase(deleteMedia.rejected, (state, action) => {
      state.error = action.payload?.error || action.error.message;
    });
  }
});

export default mediaSlice.reducer;
